import { Box, type BoxProps } from '@mui/material';
import type { FC, ReactNode } from 'react';
import { Helmet } from 'react-helmet-async';

interface Props extends BoxProps {
  children: ReactNode;
  meta?: ReactNode;
  title: string;
}

const Page: FC<Props> = ({ children, title = '', meta, ...other }) => (
  <>
    <Helmet>
      <title>{`${title} | Faks`}</title>
      {meta}
    </Helmet>

    <Box {...other}>{children}</Box>
  </>
);

export default Page;
